import { Pipe, PipeTransform } from "@angular/core";
import { FileInfo } from "../models/file-info";

@Pipe({
  name: "filterFileByYear",
})
export class FilterFileByYearPipe implements PipeTransform {
  transform(items: Array<FileInfo>, filter: number): any {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter((item) => item.year === filter);
  }
}
